import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import usePostPaymentPromotion from '../../../../services/hookService/my-account/postPaymentPromotion/usePostPaymentPromotion';
import DotsLoading from '../../../../components/dotsLoading';
import usePostActivePromotion from '../../../../services/hookService/postActivePromotion/usePostActivePromotion';
interface StepThreeProps {
  paymentWay?: string;
  type: string;
  choosed: Array<IPromotedAdvertisement>;
  paymentType: string;
  freePlans: IPromotedAdvertisement[];
  setfreePlans: React.Dispatch<React.SetStateAction<IPromotedAdvertisement[]>>;

  setStepChoosed: React.Dispatch<React.SetStateAction<string>>;
  setpaymentWay: React.Dispatch<React.SetStateAction<string | undefined>>;
}
const StepThree = ({
  paymentWay,
  choosed,
  type,
  freePlans,
  paymentType,
  setStepChoosed,
  setpaymentWay,
  setfreePlans,
}: StepThreeProps) => {
  const {guid} = useParams();
  const navigate = useNavigate();
  const {isLoading, mutate} = usePostPaymentPromotion({
    onSuccess: () => {
      setfreePlans([]);
    },
  });
  const {isLoading: ActivePromotionIsloading, mutate: mutatePromotion} =
    usePostActivePromotion({
      onSuccess: () => {
        navigate(`/my-ads/${type}/${guid}`);
        setfreePlans([]);
      },
    });

  const reducerFunction = (
    accumulator: number,
    currentValue: IPromotedAdvertisement,
  ) => {
    const foundItem = freePlans.find(item => item.guid === currentValue.guid);
    const priceValue = foundItem
      ? 0
      : currentValue.discounted_price
      ? currentValue.discounted_price
      : currentValue.price;
    return accumulator + priceValue;
  };
  return (
    <div className="flex w-full flex-col py-2">
      {choosed.reduce(reducerFunction, 0) !== 0 && (
        <>
          <p className="text-sm font-Medium">انتخاب روش پرداخت</p>
          <div className="flex flex-col gap-3 pb-3">
            {paymnetWays.map((item, index) => (
              <div className="flex items-center gap-2" key={index}>
                <input
                  id={item.value}
                  value={item.value}
                  name="platform"
                  type="radio"
                  checked={paymentWay === item.value}
                  onChange={e => setpaymentWay(e.target.value)}
                />
                <label className="flex gap-2" htmlFor={item.value}>
                  {item.image && (
                    <img
                      width={30}
                      height={38}
                      src={item.image}
                      alt={item.value}
                    />
                  )}
                  <div className="flex flex-col">
                    <span className="text-gray-950 text-md font-Regular">
                      {item.label}
                    </span>

                    {item.descirption && (
                      <span className="text-gray-700 text-sm font-Regular">
                        {item.descirption}
                      </span>
                    )}
                  </div>
                </label>
              </div>
            ))}
          </div>
        </>
      )}
      <div className="flex w-full justify-between gap-2">
        <button
          disabled={
            choosed.reduce(reducerFunction, 0) === 0
              ? false
              : paymentWay
              ? false
              : true
          }
          className="bg-farm-shop-500 h-[48px] disabled:bg-gray-500 w-[60%] px-2 rounded-[8px] flex items-center justify-center text-white text-md font-Medium"
          onClick={() => {
            if (paymentWay === 'CardToCard') {
              navigate(`/upgrade/prmotion/card_to_card/${guid}`, {
                state: {type, choosed, paymentType},
              });
            } else {
              if (choosed.reduce(reducerFunction, 0) === 0) {
                localStorage.setItem(
                  'upgradeAdvertisementUrl',
                  JSON.stringify(`upgrade/advertisement/account/${guid}`),
                );
                mutatePromotion({
                  bounch_guid_plan: freePlans
                    .map(item => item.guid)
                    .toLocaleString(),
                  guid_advertisement: guid || '',
                  type_advertisement: paymentType,
                });
              } else {
                localStorage.setItem(
                  'upgradeAdvertisementUrl',
                  JSON.stringify(`upgrade/advertisement/account/${guid}`),
                );
                mutate({
                  advertisement_guid: guid || '',
                  ipg_type: paymentWay || '',
                  package_guids:
                    choosed?.map(item => item.guid).toString() || '',
                  package_type: paymentType,
                  free_plan_guids:
                    freePlans.length !== 0
                      ? freePlans.map(item => item.guid).toLocaleString()
                      : null,
                });
              }
            }
          }}
        >
          {isLoading || ActivePromotionIsloading ? (
            <DotsLoading />
          ) : choosed.reduce(reducerFunction, 0) === 0 ? (
            'فعال سازی'
          ) : (
            'ادامه و پرداخت'
          )}
        </button>
        <button
          className="border border-farm-shop-500 text-farm-shop-500 h-[48px] w-[40%] px-2 rounded-[8px] flex items-center justify-center  text-md font-Medium"
          onClick={() => setStepChoosed('stepTwo')}
        >
          بازگشت
        </button>
      </div>
    </div>
  );
};

export default StepThree;
const paymnetWays = [
  {
    label: 'پرداخت آنلاین',
    descirption: 'درگاه پرداخت  پارسیان',
    value: 'tap',
    image: 'https://s3.ir-thr-at1.arvanstorage.ir/payment/parsian_logo.svg',
  },
  {
    label: 'پرداخت آنلاین',
    descirption: 'درگاه پرداخت ملی',
    value: 'sadad',
    image: 'https://s3.ir-thr-at1.arvanstorage.ir/payment/meli_logo.svg',
  },
  {
    label: 'پرداخت کارت به کارت',
    descirption: null,
    value: 'CardToCard',
    image: null,
  },
];
